import React from 'react';
import { PrimaryButton } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';
import { useTranslation } from 'react-i18next';

const SecondaryButton = (props) => {
  const { text, onClick, disabled = false, styleType = '', icon = '' } = props;
  const style = styleType ? styleType : '';
  const disable = disabled ? 'disabled' : '';
  const iconVal = icon.includes('chat') ? "comment-alt" : "video";
  const { t } = useTranslation();
  const assignInnerText = (event) => {
    if (iconVal === "comment-alt"){
      event.target.innerText = t('chat');
    } else {
      event.target.innerText = t('meet');
    }
  }
  return (
    icon ?
      <PrimaryButton
        className={`secondary-btn secondary-btn--${style} ${disable} `}
        onClick={onClick}
        text={text}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={iconVal} onClick={(e) => assignInnerText(e)} />
      </PrimaryButton>
      : <PrimaryButton
        className={`secondary-btn secondary-btn--${style}`}
        text={text}
        onClick={onClick}
        disabled={disabled}
      />
  );
}

export default SecondaryButton;